import { useNotificationStore } from '../../store/NotificationStore';
import styles from './NotificationWrapper.module.scss';
import Notification from './Notification';
import { useTelegram } from '@/app/providers/TelegramProvider';

export default function NotificationWrapper() {
  const showNotification = useNotificationStore(
    (state) => state.showNotification,
  );
  const { systemInsets, contentInsets } = useTelegram();

  // Определяем платформу через Telegram WebApp API
  const tg = window?.Telegram?.WebApp;
  const platform = tg?.platform || 'unknown';
  const isIOS = platform === 'ios';

  // Устанавливаем отступ в зависимости от платформы
  const platformOffset = isIOS ? 45 : 55;
  const topOffset = systemInsets.top + platformOffset;

  return (
    <div className={styles.container} style={{ top: `${topOffset}px` }}>
      <div
        className={`${styles.wrapper} ${
          showNotification ? styles.show : styles.hide
        }`}
      >
        <Notification />
      </div>
    </div>
  );
}
